<template>
  <div class="h-6 mb-8">
    <span
      v-if="hasSlot"
      class="block mr-3 mb-2 font-mono text-xxs text-gray-500 tracking-wider uppercase desktop:inline desktop:mb-0"
      ><slot />
    </span>
    <select
      v-model="data"
      class="h-6 max-w-xs text-gray-900"
      @change="onChange"
    >
      <option
        v-for="option in axisOptions"
        :key="option._id"
        :value="option._id"
        :class="option.color"
        :disabled="option.disabled"
        v-html="option.name"
      />
    </select>
    <span
      v-if="error"
      class="flex items-center mt-1 pt-1 text-error text-xs border-t border-error"
    >
      Please choose one
    </span>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'LmAxisSelect',
  props: {
    selectedAxis: {
      type: Object,
      default: null
    },
    unassignedLabel: {type: String, default: '[ Unassigned Axis ]'}
  },
  data() {
    return {
      data: null, // AxisId
      editAxisId: null,
      error: false,
      axisOptions: []
    }
  },
  computed: {
    ...mapGetters(['currentLandscape', 'axes']),
    hasSlot() {
      return !!this.$slots.default
    }
  },
  watch: {
    selectedAxis() {
      this.updateAxis()
    },
    currentLandscape() {
      this.buildTree()
    }
  },
  mounted() {
    this.buildTree()
    if (this.selectedAxis) {
      this.updateAxis()
    }
  },
  methods: {
    updateAxis() {
      this.data = this.selectedAxis ? this.selectedAxis._id : null
      this.editAxisId = this.data
    },
    buildOptionsArray(axis, depth, prefix = '') {
      if (depth > 0) {
        this.axisOptions.push({
          _id: axis._id,
          name: prefix + axis.name,
          color: axis.color // TODO: ?
        })
      }
      prefix = depth > 0 ? prefix + '&nbsp;&nbsp;' : ''
      for (let child of axis.children) {
        this.buildOptionsArray(child, depth + 1, prefix)
      }
    },
    buildTree() {
      this.axisOptions = [
        {
          _id: null,
          name: this.unassignedLabel
        }
      ]
      this.buildOptionsArray(this.axes, 0)
    },
    validateData() {
      this.error = false
      if (this.data) return true
      this.error = true
      return false
    },
    clearErrors() {
      this.error = false
    },
    onChange() {
      this.$emit('select', this.data)
      this.clearErrors()
    },
    reset() {
      this.data = this.editAxisId
      this.clearErrors()
    }
  }
}
</script>
